// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x_WM","field":"styles_field__1bn3B","fieldCol":"styles_fieldCol__3LW6E","diffCol":"styles_diffCol__32c3o","diff":"styles_diff__15UCd"};